import { myFetch, HttpMethod } from "./baseService";
import { ApiEnvelope } from "./asambleaService";

export interface ObtenerParticipantesRequest {
  asamblea_codigo: string;
  llave: string;
}

export interface ParticipanteAsambleaRecord {
  pas_codigo: number;
  pas_unidad_residencial: string;
  pas_torre: string;
  pas_torre_nombre: string;
  pas_apartamento: string;
  pas_apartamento_nombre: string;
  pas_asamblea: number;
  pas_llave: string;
  pas_fecha: string;
  pas_usuario: string;
  pas_usuario_nombre: string;
  pas_tipo_usuario: string;
  pas_tipo_usuario_nombre: string;
}

export const obtenerParticipantesAsamblea = async (
  payload: ObtenerParticipantesRequest
) => {
  const envelope = await myFetch<ApiEnvelope<ParticipanteAsambleaRecord[]>>(
    "participante_asamblea/ObtenerTodos",
    HttpMethod.POST,
    payload
  );
  return envelope;
};
